<template>
  <base-modal :title="''" @close="$emit('close')" bodyClass="pb-3 pt-4">
    <template #body>
      <div class="mt-2 px-2">
        <!-- Header with Warning Icon -->
        <div class="flex items-center m-0 mb-3" :class="headerColorClass">
          <i class="far fa-exclamation-triangle text-lg mr-2.5"></i>
          <h3 class="text-lg m-0 font-semibold" :class="headerColorClass">{{ title }}</h3>
        </div>
        
        <!-- Description -->
        <div class="text-gray-600 m-0 mb-3">
          <p class="m-0 mb-1 font-normal">{{ description }}</p>

          <ul class="list-disc mt-3 space-y-2 pl-4">
            <li v-for="(item, index) in listItems" :key="index">{{ translate(item) }}</li>
          </ul>
        </div>
        
        <!-- Warning Message -->
        <div class="rounded-md p-3 mt-3 border-solid" :class="warningBoxClass">
          {{ warningMessage }}
        </div>
      </div>
    </template>

    <template #footer>
      <div class="flex justify-end gap-3 w-full m-0 mb-4 px-2">
        <button 
          @click="$emit('close')" 
          class="py-2 px-3 rounded-md border border-gray-300 bg-white text-gray-700 hover:bg-gray-50 focus:outline-none"
        >
          {{ translate('Cancel') }}
        </button>
        <button 
          @click="$emit('confirm')" 
          class="py-2 px-3 rounded-md border focus:outline-none"
          :class="buttonColorClass"
        >
          {{ confirmButtonText }}
        </button>
      </div>
    </template>
  </base-modal>
</template>

<script>
import BaseModal from '@/components/BaseModal.vue';
import { translations } from "@/mixins";

export default {
  name: 'MaintenanceModal',
  components: {
    BaseModal,
  },
  mixins: [translations],
  props: {
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    title() {
      return this.active
        ? this.translate('Turn On Maintenance Mode')
        : this.translate('Turn Off Maintenance Mode');
    },
    description() {
      return this.active
        ? this.translate('This will put ALL Kiosks into Maintenance Mode. where:')
        : this.translate('This will take ALL kiosks out of maintenance mode, when maintenance mode is turned off:');
    },
    listItems() {
      return this.active
        ? [
            'Kiosks will be displaying a maintenance mode screen to customers.',
            'No orders can be placed.',
            'System updates might occur automatically.'
          ]
        : [
            'Kiosks will return back to normal.',
            'Customers will be able to place orders.'
          ];
    },
    headerColorClass() {
      return this.active ? 'text-red-500' : 'text-green-500';
    },
    warningBoxClass() {
      return this.active
        ? 'bg-yellow-50 border-yellow-200 text-red-600 outline-yellow-200'
        : 'bg-blue-50 border-blue-200 text-blue-700';
    },
    buttonColorClass() {
      return this.active
        ? 'bg-red-500 text-white hover:bg-red-600'
        : 'bg-green-500 text-white hover:bg-green-600';
    },
    warningMessage() {
      return this.active
        ? this.translate('Are you sure you want to turn on Maintenance mode for all kiosks?')
        : this.translate('Are you sure you want to turn off Maintenance mode for all kiosks?');
    },
    confirmButtonText() {
      return this.active
        ? this.translate('Turn On Maintenance Mode')
        : this.translate('Turn Off Maintenance Mode');
    }
  }
}
</script>
